import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "lockCheckFilled"
const LockCheckFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M22.939 15.158 16.326 22.875 11.625 18.175 13.02 16.778 16.214 19.972 21.44 13.875z" />
          <path
            fillRule="evenodd"
            d="M12 1.5C13.392 1.5 14.728 2.053 15.713 3.037 16.697 4.022 17.25 5.357 17.25 6.75V8.782L17.286 8.792C18.97 9.22 19.5 9.75 19.5 9.75V13.106L16.102 17.07 13.02 13.989 8.834 18.174 13.16 22.5H6Q5.849 22.5 5.706 22.47L5.657 22.459Q5.611 22.449 5.565 22.435L5.514 22.417Q5.47 22.403 5.43 22.387 5.406 22.377 5.382 22.365L5.303 22.328Q5.273 22.312 5.246 22.295L5.185 22.258Q5.158 22.24 5.133 22.222 5.099 22.198 5.067 22.173L5.022 22.136 4.961 22.08 4.92 22.042 4.866 21.979 4.827 21.933 4.78 21.872 4.745 21.82 4.705 21.756Q4.69 21.726 4.673 21.697L4.642 21.633 4.611 21.568 4.59 21.508 4.564 21.435Q4.524 21.3 4.508 21.153L4.5 21V9.75S5.029 9.22 6.714 8.791L6.75 8.782V6.75C6.75 5.358 7.303 4.022 8.287 3.037 9.272 2.053 10.607 1.5 12 1.5M12 3C11.005 3 10.052 3.395 9.349 4.099 8.645 4.802 8.25 5.755 8.25 6.75V8.491L8.297 8.484C9.28 8.344 10.5 8.25 12 8.25S14.719 8.344 15.703 8.484L15.75 8.491V6.75C15.75 5.755 15.355 4.802 14.651 4.099 13.948 3.395 12.995 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LockCheckFilledIcon
